import {applyMiddleware, createStore} from 'redux'
import {composeWithDevTools} from 'redux-devtools-extension/developmentOnly'
import {handleFuture, inject} from './middleware'
import reducer from './reducer'

import * as app from './app/actions'
import * as login from './login/actions'
import * as search from './search/actions'
import * as report from './report/actions'
import * as decisionTree from './decision-tree/actions'
import * as monitoring from './monitoring/actions'
import * as modal from './modal/actions'
import * as analysis from './analysis/actions'
import * as translations from './monitoring-translations/actions'

export const appActions = app
export const loginActions = login
export const searchActions = search
export const reportActions = report
export const decisionTreeActions = decisionTree
export const monitoringActions = monitoring
export const modalActions = modal
export const analysisActions = analysis
export const translationsActions = translations

export default (deps) =>
  createStore(
    reducer,
    composeWithDevTools(
      applyMiddleware(
        inject(deps),
        handleFuture,
      ),
    )
  )



// WEBPACK FOOTER //
// ./src/store/index.js